import axios from 'axios';

export default {
	
	pre_insertar(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	buscar_nombre(p_email, p_usuario, p_nombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.buscar_nombre",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nombre": p_nombre
				  })
			})
	},

	buscar_por_id(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.buscar_id",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	buscar(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	insertar(p_email, p_usuario, p_poliza, p_monedapol, p_mtodenun, p_fdenun, p_ejesin, p_asisin, p_observacion) {
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_garcorrespon.insertar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_monedapol": p_monedapol,
				"p_mtodenun": p_mtodenun, 
				"p_fdenun": p_fdenun,
				"p_ejesin": p_ejesin,
				"p_asisin": p_asisin, 
				"p_observacion": p_observacion				
				})
		})
	},

	modificar(p_email, p_usuario, p_correlativo, p_mtodenun, p_fdenun, p_ejesin, p_asisin, p_observacion){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_garcorrespon.modificar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_correlativo": p_correlativo,
				"p_mtodenun": p_mtodenun, 
				"p_fdenun": p_fdenun,
				"p_ejesin": p_ejesin,
				"p_asisin": p_asisin, 
				"p_observacion": p_observacion				
				})
		})
	},


	recuperar_corresp(p_email, p_usuario, p_correlativo){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_garcorrespon.recuperar_corresp",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_correlativo": p_correlativo,
				})
		})
	},

	recuperar_poliza(p_email, p_usuario, p_poliza, p_codigo, p_participa, p_fedesde, p_fehasta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar_poliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_codigo": p_codigo,
					"p_participa": p_participa,
					"p_fedesde": p_fedesde,
					"p_fehasta": p_fehasta
				  })
			})
	},

	recuperar_detpoliza(p_email, p_usuario, p_poliza, p_item, p_endoso) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar_detpoliza",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_item": p_item,
					"p_endoso": p_endoso
				  })
			})
	},

	recuperar_polcorsin(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar_polcorsin",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	buscarPoliza(p_email, p_poliza, p_afianzado, p_beneficiario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.buscar_poliza",
				"p_args_in": JSON.stringify({
					"p_poliza": p_poliza,
                    "p_afianzado": p_afianzado,
					"p_beneficiario": p_beneficiario
				  })
			})
	},

	DocContishare(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar_doccontishare",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},
	
	guardar_link_contishare(p_email, p_usuario, p_siniestro, p_link, p_nombredoc) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.guardar_link_contishare",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_link": p_link,
					"p_nombredoc": p_nombredoc,
				  })
			})
	},

	finiquitos(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.recuperar_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	mail_copianovalida(p_email, p_usuario, p_poliza, p_endoso) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.mail_copianovalida",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_endoso": p_endoso
				  })
			})
	},

	pre_InserCompl(p_email, p_usuario, p_tarea, p_actividad) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.pre_InserCompl",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_tarea": p_tarea,
                    "p_actividad": p_actividad
				  })
			})
	},

	                      
	insertar_tarea(p_email, p_usuario, p_tarea, p_actividad, p_asistente, 
				p_feinicio, p_fevencimiento, p_fetermino, p_resultado, 
				p_poliza, p_siniestro, p_correspondencia, p_prioridad, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garcorrespon.insertar_tarea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_tarea": p_tarea,
                    "p_actividad": p_actividad,
					"p_asistente": p_asistente,
					"p_feinicio": p_feinicio,
					"p_fevencimiento": p_fevencimiento,
					"p_fetermino": p_fetermino,
					"p_resultado": p_resultado,
					"p_poliza": p_poliza,
					"p_siniestro": p_siniestro,
					"p_correspondencia": p_correspondencia,
					"p_prioridad": p_prioridad,
					"p_observacion": p_observacion
				  })
			})
	},
}